import React from "react";

const GridLoadError = ({ title, onRetry }) => (
  <div
    className="d-flex flex-column align-items-center justify-content-center p-5 h-100"
    role="alert"
  >
    <span>Couldn't load {title}.</span>
    {onRetry && (
      <button
        type="button"
        className="btn btn-outline-primary btn-sm mt-3"
        onClick={() => onRetry()}
      >
        Retry
      </button>
    )}
  </div>
);

export default GridLoadError;
